import { useHistory } from 'react-router';

class ReactRouterService {
  private _history?: ReturnType<typeof useHistory>;

  get history(): ReturnType<typeof useHistory> {
    const history = this._history;

    if (!history) {
      throw new Error('History is not initialized');
    }

    return history;
  }

  initHistory(history: ReturnType<typeof useHistory>) {
    this._history = history;
  }

  addUrlQueryParams = (queries: Record<string, string | number>) => {
    const { pathname, search } = this.history.location;
    const searchParams = new URLSearchParams(search);

    for (const key in queries) {
      searchParams.set(key, String(queries[key]).toLowerCase());
    }

    this.history.push({
      pathname,
      search: searchParams.toString(),
    });
  };

  deleteUrlQueryParams = (): void => {
    const { pathname } = this.history.location;

    this.history.replace({
      pathname,
      search: '',
    });
  };
}

export const reactRouterService = new ReactRouterService();
